(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rekapi-timeline", [], factory);
	else if(typeof exports === 'object')
		exports["rekapi-timeline"] = factory();
	else
		root["rekapi-timeline"] = factory();
})(window, function() {
return 